module.exports = __webpack_public_path__ + "img/classic-border.d88e299d.svg";